/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetSegmentsOfInterestPathParams = NonNullable<operations['getSegmentsOfInterest']['parameters']['path']>;

export type GetSegmentsOfInterestQueryParams = NonNullable<operations['getSegmentsOfInterest']['parameters']['query']>;

export interface Input extends GetSegmentsOfInterestPathParams {
  apiVersion?: string;
  query: GetSegmentsOfInterestQueryParams;
}

export async function getSegmentsOfInterest(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET(
    '/internal/projects/{projectKey}/environments/{environmentKey}/experiments/{experimentKey}/metrics/{metricKey}/segments-of-interest',
    {
      params: { path, query },
      headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
      signal,
    },
  );
}
